import { countProducts } from "./countProducts";

export const groupProductsByStore = products =>
  countProducts(products).reduce((prev, curr) => {
    const store = curr.store;
    if (Object.keys(prev).includes(store)) {
      const existing = prev[store];
      return { ...prev, [store]: [...existing, curr] };
    } else return { ...prev, [store]: [curr] };
  }, {});
